import { render } from "./NoteTagsField.vue?vue&type=template&id=16f6e0be"
import script from "./NoteTagsField.vue?vue&type=script&lang=js"
export * from "./NoteTagsField.vue?vue&type=script&lang=js"

import "@/modules/consultant/styles/LabelDropdown.css?vue&type=style&index=0&lang=css&external"
import "@/styles/NoteTagsField.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__